import styled, { css } from 'styled-components';

const mapPosition = (props) => {
  const { measures, position, width } = props;
  const elementWidth = width != null ? width : measures.width;
  const widthRest = width ? width - measures.width : 0;
  const rightElementWidth = measures.left + measures.width;
  const leftElementWidth = measures.left;
  switch (position) {
    case "left":
      return css`
        left: ${leftElementWidth}px;
        width: ${elementWidth}px;
      `;
    case "right":
      return css`
        left: ${rightElementWidth - elementWidth}px;
        width: ${elementWidth}px;
      `;
    case "center":
      return css`
        left: ${leftElementWidth - widthRest / 2}px;
        width: ${elementWidth}px;
      `;
  }
};
const OverlayStyled = styled.div`
  position: absolute;
  z-index: 3;
  top: ${(props) => props.measures.y + props.measures.height}px;
  min-height: 8px;
  ${mapPosition}
  isolation: isolate;

  .Overlay {
  }
`;

export { OverlayStyled as default };
//# sourceMappingURL=bundle.esm3.js.map
